<template>
  <div class="index-banner" @mouseover="isButtonShow=true" @mouseout="isButtonShow=false">
    <div class="topic-preview-wrapper">
    <div class="topic-preview-list-wrapper">
      <img id="bg" src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/banner/banner_bg.png">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              v-for="(item,index) in bannerlist"
              :key="index"
              @mouseover="overStyle(item)"
              :style="{width: offsetWidth+'px'}"
              :class="[{'active':item.active}, 'swiper-slide']"
              @mouseout="outStyle(item)"
              @click.stop="videoPlayer(item.src)"
            >
              <img :src="item.pic" alt="">
            </div>
          </div>
        </div>
        <span
          class="button-span button-last swiper-button-prev"
          v-show="isButtonShow && !this.$store.state.isMobile"
          @click.stop="lastEvent"
        ></span>
        <span
          class="button-span button-next swiper-button-next"
          v-show="isButtonShow && !this.$store.state.isMobile"
          @click.stop="nextEvent"
        ></span>
        <!-- <ul class="topic-preview"  :style="{width: offsetWidth*bannerlist.length+'px'}" ref="banner"> 
          	<li class="banner-item" v-for="(item,index) in bannerlist" :key="index" @mouseover="overStyle(item)" :style="{width: offsetWidth+'px'}"  :class="{'active':item.active}" @mouseout="outStyle(item)" @click.stop="videoPlayer(item.src)">
              <div class="b-link" target="_blank" :style="{width: offsetWidth+'px'}">
                <img :src="item.pic" :style="{width: offsetWidth+'px'}">
              </div>
              <span class="describe" >{{item.describe}}</span>
            </li>
        </ul>-->
        <div class="s-bottom">
          <ul class="slide-bar swiper-pagination">
            <!-- <li
              :class="{on: count == index}"
              v-for="(item, index) in bannerlist"
              :key="index"
              @click="cutItem(index)"
            ></li> -->
          </ul>
        </div>
      </div>
    </div>
    <video-player
      v-show="videoShow"
      class="video-player-box"
      ref="videoPlayer"
      :events="events"
      :options="playerOptions"
      :playsinline="true"
      customEventName="customstatechangedeventname"
      width="100%"
      height="100%"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @fullscreenchange="onPlayerFullScreenchange($event)"
      @ready="playerReadied"
    ></video-player>
  </div>
</template>

<script>
import banner1 from "@/assets/image/index-banner1.png";
import banner2 from "@/assets/image/index-banner2.png";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import Swiper from "swiper";
export default {
  props: {
    width: {
      type: Number
    }
  },
  data() {
    return {
      count: 0,
      show: false,
      videoShow: false,
      interval: Function,
      events: ["fullscreenchange"],
      bannerlist: [
        {
          pic:
            "https://krk-website.oss-cn-beijing.aliyuncs.com/img/banner/banner1.png"
        },
        {
          pic:
            "https://krk-website.oss-cn-beijing.aliyuncs.com/img/banner/banner2.png"
        },
        {
          pic:
            "https://krk-website.oss-cn-beijing.aliyuncs.com/img/banner/banner3.png"
        },
        {
          pic:
            "https://krk-website.oss-cn-beijing.aliyuncs.com/img/banner/banner4.png"
        },
        {
          pic:
            "https://krk-website.oss-cn-beijing.aliyuncs.com/img/banner/banner5.png"
        }
      ],
      isButtonShow: false,
      playerOptions: {
        // videojs options
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src:
              "https://krk-website.oss-cn-beijing.aliyuncs.com/img/banner/banner.mp4" //视频地址
          }
        ],
        poster:
          "https://krk-website.oss-cn-beijing.aliyuncs.com/img/banner/banner8.jpg"
      }
    };
  },
  computed: {
    offsetWidth: function() {
      let width = 0;
      if (this.width > 1200) {
        width = this.width;
      } else {
        // width = 1200;
        width = document.body.clientWidth;
        console.log(document.body.clientWidth);
      }
      return width;
    },
    player: {
      get: function() {
        return this.$refs.videoPlayer.player;
      },
      set: function(val, old) {}
    }
  },
  mounted() {
    this.banner = new Swiper(".swiper-container", {
      slidesPerView: 1,
      // autoplay:true,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,    // 用户操作swiper之后，是否禁止autoplay
      },
      direction: "horizontal",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable :true
      },
    });
    // this.startInterval(); //轮播开始
    // this.exitFullScreen(this.exitScreen); //退出全屏
  },
  watch: {
    isButtonShow: {
      handler(val, old) {
        if (val == true) {
          clearInterval(this.interval);
        } else {
          this.startInterval();
        }
      }
    }
  },
  methods: {
    // exitScreen() {
    //   //退出全屏事件
    //   this.videoShow = false;
    //   this.player.pause();
    // },
    cutItem(index) {
      //底部按钮点击事件
      this.count = index;
      let distance = -100 * this.count;
      let left = distance + "%";
      this.$refs.banner.style.marginLeft = left;
    },
    startInterval() {
      //轮播图定时滚动
      this.interval = setInterval(() => {
        this.count++;
        if (this.count === this.bannerlist.length) {
          this.count = 0;
        }
        let distance = -100 * this.count;
        let left = distance + "%";
        if (this.$refs.banner) {
          this.$refs.banner.style.marginLeft = left;
        }
      }, 5000);
    },
    overStyle(item) {
      var _this = this;
      this.$nextTick(function() {
        this.bannerlist.forEach(function(item) {
          _this.$set(item, "active", false);
        });
        this.$set(item, "active", true);
        clearInterval(this.interval);
      });
    },
    outStyle(item) {
      this.$set(item, "active", false);
    },
    lastEvent() {
      clearInterval(this.interval);
      if (this.count === 0) {
        this.count = this.bannerlist.length - 1;
      } else {
        this.count--;
      }
      let distance = -100 * this.count;
      let left = distance + "%";
      if (this.$refs.banner) {
        this.$refs.banner.style.marginLeft = left;
      }
    },
    nextEvent() {
      // clearInterval(this.interval);
      // if (this.count === this.bannerlist.length - 1) {
      //   this.count = 0;
      // } else {
      //   this.count++;
      // }
      // let distance = -100 * this.count;
      // let left = distance + "%";
      // if (this.$refs.banner) {
      //   this.$refs.banner.style.marginLeft = left;
      // }
    },
    videoPlayer(src) {
      this.$uweb.trackEvent("播放视频", "点击");
      this.player.src(src);
      this.videoShow = true;
      //全屏播放
      this.player.requestFullscreen();
      this.player.play();
    },
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    playerStateChanged(playerCurrentState) {},
    playerReadied(player) {
      //  this.player.isFullscreen(true);
    },
    onPlayerLoadeddata(player) {},
    onPlayerTimeupdate(player) {
      if (!player.isFullscreen_) {
        this.videoShow = false;
      }
    },
    onPlayerPlaying(player) {},
    onPlayerCanplay(player) {},
    onPlayerCanplaythrough(player) {},
    onPlayerEnded(player) {},
    onPlayerWaiting(player) {},
    onPlayerFullScreenchange(player) {
      if (!player.isFullscreen_) {
        this.videoShow = false;
      }
    }
  },
  components: {
    videoPlayer
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../../../node_modules/swiper/dist/css/swiper.css";
.index-banner {
  width: 100%;
  height: 100%;
  position: relative;
  #bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 274px;
    z-index: 2;
  }
  .topic-preview-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    .swiper-container {
      width: 100%;
      .swiper-wrapper {
        width: 100%;
      }
      .swiper-slide {
        width: 100%;
        img {
          width: 100%;
          height: auto;
          float: left;
        }
      }
    }
    a {
      color: #fff;
    }
    .topic-preview-list-wrapper {
      height: 100%;
      overflow: hidden;
      border-radius: 4px;
      position: relative;
      .topic-preview {
        height: 100%;
        transition: 0.2s;
        li.banner-item {
          position: relative;
          // min-width: 1200px;
          width: 100%;
          height: 100%;
          float: left;
          div.b-link {
            display: inline-block;
            width: 100%;
            height: 100%;
            float: left;
            img {
              display: block;
              width: 100%;
              height: auto;
              cursor: pointer;
            }
          }
          .describe {
            display: none;
            position: absolute;
            font-size: 16px;
            font-size: #333;
            top: 50%;
            left: 50%;
          }
        }
        li.banner-item.active {
          .describe {
            display: block;
          }
        }
      }
    }

    .button-span {
      position: absolute;
      top: 50%;
      margin-top: -30px;
      display: block;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      line-height: 60px;
      opacity: 0.5;
      color: #fff;
      font-size: 17px;
      text-align: center;
      cursor: pointer;
      outline: none;
    }
    span.button-last {
      left: 30px;
      margin-left: 80px;
      background: url(../../assets/image/icon.png) no-repeat;
      background-position: -220px -20px;
    }
    span.button-next {
      right: 30px;
      margin-right: 80px;
      background: url(../../assets/image/icon.png) no-repeat;
      background-position: -320px -20px;
    }
    .s-bottom {
      position: absolute;
      bottom: 150px;
      left: 0;
      width: 100%;
      height: 35px;
      border-radius: 0 0 4px 4px;
      .slide-bar,
      .swiper-pagination {
        position: absolute;
        z-index: 3;
        bottom: 6px;
        left: 50%;
        margin-left: -47px;
        li,
        .swiper-pagination-bullet {
          float: left;
          width: 10px;
          height: 10px;
          border: 2px solid #ffffff;
          border-radius: 50%;
          margin-left: 5px;
          background: rgba(255, 255, 255, 1);
          cursor: pointer;
          outline: none;
          opacity: 1;
        }
        li.on,
        .swiper-pagination-bullet-active {
          background: rgba(0, 52, 120, 1);
          opacity: 0.85;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .index-banner {
    .topic-preview-wrapper {
      .topic-preview-list-wrapper {
        #bg {
          height: 97px;
        }
      }
      .s-bottom {
        bottom: 10px;
        .swiper-pagination .swiper-pagination-bullet {
          float: left;
          width: 7px;
          height: 7px;
          border: 1px solid #ffffff;
        }
        .slide-bar,.swiper-pagination {
          margin-left: -35px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/Banner.vue